import api from '@/api'
import axios from 'axios'

//获取发票列表
export async function getInvoiceList() {
  return api.get('api/services/app/FrontendInvoiceInfo/GetInvoiceInfos')
}

//获取发票详情
export async function getInvoice(data) {
  return api.get('api/services/app/FrontendInvoiceInfo/GetInvoiceInfo?id='+data.id)
}

//修改或编辑
export async function createOrEdit(data) {
  return  api.post('api/services/app/FrontendInvoiceInfo/CreateOrUpdate', data)
}

//删除
export async function Delete(data) {
  return  api.post('api/services/app/FrontendInvoiceInfo/DoRemove?', data)
}



// WEBPACK FOOTER //
// ./src/api/invoice.js